import '../../../../assets/ds-font.css';
import '../../assets/third-party-css/index.css';
import { dsTheme } from '../../styles/ds/ds-theme';
import { BrandDescriptor, ModuleDescriptor } from './brand-loader';

const dsModules: ReadonlyArray<ModuleDescriptor> = Object.freeze([
  {
    externalName: 'VACS',
    entryPoint: async () => {
      await import('../../../location/common/common-location');
      await import('../../components/input/slider/general/slider-common');
      await import('../../components/input/radio-button/ds/ds-radio-button');
      await import('../../../vacs/common/common-vacs');
      return import('../../../vacs/ds/ds-vacs').then((vacs) => vacs.VACS);
    },
    labelPrefix: 'vacs',
  },
  {
    externalName: 'CarSearchWidget',
    entryPoint: async () => {
      await import('../../components/input/slider/general/slider-common');
      await import('../../../car-search-widget/common/common-car-search-widget');
      return import('../../../car-search-widget/ds/ds-car-search-widget').then((csw) => csw.CarSearchWidget);
    },
    labelPrefix: 'widget',
  },
  {
    externalName: 'OfferWidget',
    entryPoint: async () => {
      await import('../../../offer-widget/common/common-offer-widget');
      return import('../../../offer-widget/ds/ds-offer-widget').then((ow) => ow.DsOfferWidgetComponent);
    },
    labelPrefix: 'widget',
  },
  {
    externalName: 'WelcomeTextWidget',
    entryPoint: async () => {
      await import('../../../welcome-text/common/common-welcome-text-widget');
      return import('../../../welcome-text/ds/ds-welcome-text-widget').then((wtw) => wtw.WelcomeTextWidget);
    },
    labelPrefix: 'widget',
  },
  {
    externalName: 'Advisor',
    entryPoint: async () => {
      await import('../../../advisor/common/common-advisor');
      return import('../../../advisor/ds/ds-advisor').then((adv) => adv.DsAdvisor);
    },
    labelPrefix: 'widget',
  },
  {
    externalName: 'Article',
    entryPoint: async () => {
      await import('../../../article/common/common-article');
      return import('../../../article/ds/ds-article').then((art) => art.ArticlePage);
    },
    labelPrefix: 'article',
  },
  {
    externalName: 'Location',
    entryPoint: async () => {
      await import('../../../location/common/common-location');
      return import('../../../location/ds/ds-location').then((loc) => loc.LocationPage);
    },
    labelPrefix: 'location',
  },
  {
    externalName: 'LocationWidget',
    entryPoint: async () => {
      await import('../../../location/common/common-location');
      return import('../../../location/ds/ds-location-widget').then((loc) => loc.LocationWidget);
    },
    labelPrefix: 'widget',
  },
  {
    externalName: 'LandingPageWidget',
    entryPoint: async () => {
      await import('../../../landing-page-widget/common/common-landing-page-widget');
      return import('../../../landing-page-widget/ds/ds-landing-page-widget').then((lap) => lap.DsLandingPageWidget);
    },
    labelPrefix: 'widget',
  },
  {
    externalName: 'CommonForm',
    entryPoint: async () => {
      // await import('../../../common/form/controls/text/common-text-input');
      // return import('../../../common/form/common/common-form').then((loc) => loc.CommonForm)
      await import('dompurify');
      await import('classnames');
      await import('resize-observer-polyfill');
      await import('../../../vacs/common/vehicle-list.service');
      return import('../../../common/form/ds/ds-form').then((loc) => loc.DsForm);
    },
    labelPrefix: 'widget',
  },
  {
    externalName: 'Webform',
    entryPoint: async () => {
      await import('dompurify');
      await import('classnames');
      await import('resize-observer-polyfill');
      await import('../../../location/common/common-location');
      await import('../../../common-form-widget/common-form-index-widget');
      return import('../../../common-form-widget/ds/ds-common-form-widget').then((form) => form.DsCommonFormWidget);
    },
    labelPrefix: 'widget',
  },
  {
    externalName: 'StandardProWidget',
    entryPoint: async () => {
      await import('../../../location/common/common-location');
      await import('../../../standard-pro-widget/ds/ds-standard-pro-image-and-text-widget');
      await import('../../../standard-pro-widget/ds/ds-standard-pro-downloads-widget');
      await import('../../../standard-pro-widget/ds/ds-standard-pro-banner-widget');
      return import('../../../standard-pro-widget/ds/ds-standard-pro-widget').then((spw) => spw.DsStandardProWidget);
    },
    labelPrefix: 'widget',
  },
  {
    externalName: 'StandardProWidgetText',
    entryPoint: async () => {
      return import('../../../standard-pro-widget/ds/ds-standard-pro-text-widget').then(
        (spw) => spw.DsStandardProWidgetText
      );
    },
    labelPrefix: 'widget',
  },
  {
    externalName: 'StandardProWidgetBanner',
    entryPoint: async () => {
      return import('../../../standard-pro-widget/ds/ds-standard-pro-banner-widget').then(
        (spw) => spw.DsStandardProWidgetBanner
      );
    },
    labelPrefix: 'widget',
  },
  {
    externalName: 'StandardProWidgetDownloads',
    entryPoint: async () => {
      return import('../../../standard-pro-widget/ds/ds-standard-pro-downloads-widget').then(
        (spw) => spw.DsStandardProWidgetDownloads
      );
    },
    labelPrefix: 'widget',
  },
  {
    externalName: 'StandardProWidgetGallery',
    entryPoint: async () => {
      return import('../../../standard-pro-widget/ds/ds-standard-pro-gallery-widget').then(
        (spw) => spw.DsStandardProWidgetGallery
      );
    },
    labelPrefix: 'widget',
  },
  {
    externalName: 'StandardProWidgetImageAndText',
    entryPoint: async () => {
      return import('../../../standard-pro-widget/ds/ds-standard-pro-image-and-text-widget').then(
        (spw) => spw.DsStandardProWidgetImageAndTextWidget
      );
    },
    labelPrefix: 'widget',
  },
  {
    externalName: 'StandardProWidgetMultipleImageAndText',
    entryPoint: async () => {
      return import('../../../standard-pro-widget/ds/ds-standard-pro-multi-image-and-text-widget').then(
        (spw) => spw.DsStandardProWidgetMultiImageAndText
      );
    },
    labelPrefix: 'widget',
  },
  {
    externalName: 'StandardProWidgetTable',
    entryPoint: async () => {
      return import('../../../standard-pro-widget/ds/ds-standard-pro-table-widget').then(
        (spw) => spw.DsStandardProWidgetTable
      );
    },
    labelPrefix: 'widget',
  },
  {
    externalName: 'StandardProWidgetVideo',
    entryPoint: async () => {
      return import('../../../standard-pro-widget/ds/ds-standard-pro-video-widget').then(
        (spw) => spw.DsStandardProWidgetVideo
      );
    },
    labelPrefix: 'widget',
  },
  {
    externalName: 'StandardProWidgetTabs',
    entryPoint: async () => {
      await import('../../../standard-pro-widget/ds/ds-standard-pro-image-and-text-widget');
      await import('../../../standard-pro-widget/ds/ds-standard-pro-downloads-widget');
      await import('../../../standard-pro-widget/ds/ds-standard-pro-banner-widget');
      await import('../../../standard-pro-widget/ds/ds-standard-pro-video-widget');
      return import('../../../standard-pro-widget/ds/ds-standard-pro-tabs-widget').then(
        (spw) => spw.DsStandardProWidgetTabs
      );
    },
    labelPrefix: 'widget',
  },
  {
    externalName: 'Showroom',
    entryPoint: async () => {
      await import('../../../showroom/common/common-showroom');
      return import('../../../showroom/ds/ds-showroom').then((showroom) => showroom.DsShowroom);
    },
    labelPrefix: 'showroom',
  },
  {
    externalName: 'ModShowroom',
    entryPoint: async () => {
      await import('dompurify');
      await import('../../../showroom/common/common-showroom');
      return import('../../../showroom/ds/v2/ds-showroom_v2').then((showroom) => showroom.DsShowroomV2Component);
    },
    labelPrefix: 'showroom',
  },
  {
    externalName: 'LeasingAndUsedCarsWidget',
    entryPoint: async () => {
      await import('../../components/input/slider/general/slider-common');
      await import('../../../leasing-and-used-cars-widget/common/common-leasing-and-used-cars-widget');
      return import('../../../leasing-and-used-cars-widget/ds/ds-leasing-and-used-cars-widget').then(
        (so) => so.DsLeasingAndUsedCarsWidget
      );
    },
    labelPrefix: 'widget',
  },
  {
    externalName: 'BannerWidget',
    entryPoint: async () => {
      return import('../../../banner/ds/ds-banner-widget').then((banner) => banner.DsBannerWidget);
    },
    labelPrefix: 'widget',
  },
  {
    externalName: 'TestPageWidget',
    entryPoint: async () => {
      return import('../../../test-page/ds/ds-test-page-widget').then((tpw) => tpw.TestPageWidget);
    },
    labelPrefix: 'widget',
  },
  {
    externalName: 'FooterWidget',
    entryPoint: async () => {
      return import('../../../footer/ds/ds-footer-widget').then((footer) => footer.FooterWidget);
    },
    labelPrefix: 'widget',
  },
]);

export default [dsModules, dsTheme] as BrandDescriptor;
